import React from 'react'
import styled from '@emotion/styled'

import {SkeletonLoader} from '@vio/atlas/SkeletonLoader'
import {cssTheme} from '@vio/atlas/themes'

import {PriceWrapper} from '../PriceComposition'
import {OfferLayoutBaseProps, OfferLayoutLoadingProps} from '.'
import {useCashbackPositioning} from './useCashbackPositioning'

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${cssTheme.layout.spacing.s700};
`

const LeftWrapper = styled.div`
  text-align: left;
`

const RightWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;

  ${PriceWrapper} {
    &.--column {
      align-items: flex-end;
    }
  }
`

const RightInnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`

export const CompactDefaultLayout: React.FC<
  OfferLayoutBaseProps | OfferLayoutLoadingProps
> = ({
  isLoading,
  priceComponent,
  providerLogoComponent,
  ctaComponent,
  roomLabelsComponent,
  tagComponent,
  dataId,
  cashbackComponent,
  showCashbackLineBreak
}) => {
  const {showCashbackOnRight, renderRoomLabelsWithCashback} =
    useCashbackPositioning({
      cashbackComponent,
      roomLabelsComponent,
      lineBreak: showCashbackLineBreak
    })

  if (isLoading)
    return (
      <Wrapper data-id="loader">
        <div>
          <SkeletonLoader width={90} marginTop={0} />
        </div>
        <div>
          <SkeletonLoader width={130} marginTop={0} align="right" />
        </div>
      </Wrapper>
    )

  return (
    <Wrapper data-id={dataId}>
      <LeftWrapper>
        {tagComponent}
        {providerLogoComponent}
        {renderRoomLabelsWithCashback()}
      </LeftWrapper>
      <RightWrapper>
        <RightInnerWrapper>
          {priceComponent}
          {showCashbackOnRight}
        </RightInnerWrapper>
        {ctaComponent}
      </RightWrapper>
    </Wrapper>
  )
}
